export default [
  {
    path: '/customer',
    component: () => import(/* webpackChunkName: "customer" */ '@/pages/customer/index.vue'),
    name: 'customer.index',
    meta: {
      title: '客户列表',
    },
  },
  {
    path: '/customer/add',
    component: () => import(/* webpackChunkName: "customer" */ '@/pages/customer/add.vue'),
    name: 'customer.add',
    meta: {
      title: '新增客户',
    },
  },
  {
    path: '/customer/edit/:customer_id',
    component: () => import(/* webpackChunkName: "customer" */ '@/pages/customer/add.vue'),
    name: 'customer.edit',
    meta: {
      title: '编辑客户',
    },
  },
  {
    path: '/customer/people/:customer_id',
    component: () => import(/* webpackChunkName: "customer" */ '@/pages/customer/people.vue'),
    name: 'customer.people',
    meta: {
      title: '联系人列表',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/customer.js